import styled, { AnyStyledComponent } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

import DownArrowImage from '../../assets/images/down-arrow.svg'

export const SecondaryFAQContainer = styled.div`
    margin-top: 3.5rem;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 1.25rem;
    }
`

export const FAQCellContainer = styled.div<{ isVisible: boolean }>`
    ${({ isVisible }) => !isVisible && `display: none`};
`

export const ShowMoreText = styled.p`
    height: ${props => props.theme.layout.xxSmall};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    font-weight: normal;
    text-align: ${props => props.theme.style.textAlign.center};
    line-height: normal;
    margin: 1.875rem auto 0rem auto;
    color: ${props => props.theme.colors.tfwBlack87};
    text-decoration: underline;
    cursor: pointer;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* tablets */
        margin: 2.18rem auto 0;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        /* For desktops: */
        margin: 3.1rem auto 0;
    }
`

export const DownArrow = styled(DownArrowImage as AnyStyledComponent)`
    width: 0.625rem;
    height: 0.625rem;
`
